var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AbsBox',{staticClass:"border-danger",staticStyle:{"border-left-style":"solid","border-left-width":"3px","pointer-events":"none"}})}
var staticRenderFns = []

export { render, staticRenderFns }